/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
export type IActiveShipmentFragment = { __typename?: 'Shipment' } & Pick<
  Types.IShipment,
  'id' | 'marketplaceId'
> & {
    drivers?: Types.Maybe<
      Array<{ __typename?: 'Driver' } & Pick<Types.IDriver, 'id' | 'firstName' | 'lastName'>>
    >
    etaObject?: Types.Maybe<
      { __typename?: 'EtaObject' } & Pick<
        Types.IEtaObject,
        'onTime' | 'lastPingLatitude' | 'lastPingLongitude'
      >
    >
    stops: Array<{ __typename?: 'Stops' } & Pick<Types.IStops, 'id' | 'city' | 'stateCode'>>
    trackingSummary?: Types.Maybe<
      { __typename?: 'ShipmentTrackingSummary' } & Pick<
        Types.IShipmentTrackingSummary,
        'isTracking'
      >
    >
    truck?: Types.Maybe<{ __typename?: 'Truck' } & Pick<Types.ITruck, 'id' | 'truckNumber'>>
  }

export const ActiveShipmentFragmentDoc = gql`
  fragment ActiveShipment on Shipment {
    id
    marketplaceId
    drivers {
      id
      firstName
      lastName
    }
    etaObject {
      onTime
      lastPingLatitude
      lastPingLongitude
    }
    stops {
      id
      city
      stateCode
    }
    trackingSummary {
      isTracking
    }
    truck {
      id
      truckNumber
    }
  }
`
